import {
  Box,
  Button,
  ButtonGroup,
  Card,
  Divider,
  HorizontalGrid,
  HorizontalStack,
  Icon,
  Text,
  TextField,
  useBreakpoints,
} from '@shopify/polaris';
import { SearchMinor } from '@shopify/polaris-icons';
import DepositScopeFilter from '../../../UI/Reports/DepositScopeFilter';
import FilterSelect from '../../../UI/Products/FilterSelect';
import { SEASON_OPTIONS } from './constants';
import { SingleSelectButton } from './SingleSelectButton';
import { DEPOSIT_TYPE_OPTIONS, buildDepositScopeLabel } from '../../../../helpers/depositTypes';

/**
 * Card de filtros del report de Eficacia. Recibe el estado plano que
 * expone `useEfficacyFilters` + las opciones de Año (`yearOptions`).
 *
 * En `lgUp` aplica el patrón clásico (buscador izquierda + segmented
 * derecha); por debajo de `lg` se apila en vertical y suelta el
 * `segmented` para que los botones envuelvan (wrap) sin apelmazarse.
 */
export const FiltersCard = ({
  yearOptions,
  season,
  setSeason,
  year,
  setYear,
  depositsValue,
  depositRolesValue,
  depositGroupsValue,
  setDepositScope,
  depositOptions,
  groupOptions,
  filters,
  handleFilter,
  clearFilters,
  familySearch,
  setFamilySearch,
}) => {
  const { lgUp } = useBreakpoints();

  const depositsLabel = buildDepositScopeLabel({
    depositsValue,
    depositRolesValue,
    depositGroupsValue,
    groupOptions,
  });

  return (
    <Card roundedAbove="sm">
      <HorizontalGrid
        columns={{ xs: '1fr', sm: '1fr', md: '1fr', lg: '3fr 5fr', xl: '3fr 7fr' }}
        gap={{ xs: '3', sm: '3', md: '3', lg: '3', xl: '3' }}
      >
        <Box>
          <Text variant="headingMd" as="h4">
            Búsqueda
          </Text>
          <Box border="divider" borderRadius="base" minHeight=".5rem" />
          <TextField
            prefix={<Icon source={SearchMinor} color="inkLighter" />}
            label="Buscar serie / familia"
            labelHidden
            placeholder="Buscar serie / familia"
            value={familySearch}
            onChange={setFamilySearch}
            clearButton
            onClearButtonClick={() => setFamilySearch('')}
            autoComplete="off"
          />
        </Box>
        <HorizontalStack align={lgUp ? 'end' : 'start'} gap="2" wrap>
          <Box>
            <Text variant="headingMd" as="h4">
              Categorización
            </Text>
            <Box border="divider" borderRadius="base" minHeight=".5rem" />
            <ButtonGroup segmented={lgUp}>
              <SingleSelectButton options={SEASON_OPTIONS} value={season} onChange={setSeason} />
              <SingleSelectButton label="Año" options={yearOptions} value={year} onChange={setYear} />
              <DepositScopeFilter
                title={depositsLabel}
                allSelected={depositsValue === 'ALL'}
                roles={depositRolesValue ? depositRolesValue.split(':').filter(Boolean) : []}
                groups={depositGroupsValue ? depositGroupsValue.split(':').filter(Boolean) : []}
                deposits={
                  depositsValue && depositsValue !== 'ALL' ? depositsValue.split(':').filter(Boolean) : []
                }
                roleOptions={DEPOSIT_TYPE_OPTIONS}
                groupOptions={groupOptions}
                depositOptions={depositOptions}
                onChange={setDepositScope}
              />
              {Object.values(filters)
                .filter((f) => f.bundle)
                .map((f) => (
                  <FilterSelect
                    {...f}
                    options={f.options ?? []}
                    key={f.slug}
                    defaultValue={f.value ?? ''}
                    onFilterChange={handleFilter}
                  />
                ))}
            </ButtonGroup>
          </Box>
        </HorizontalStack>
      </HorizontalGrid>
      <Box minHeight=".75rem" />
      <Divider />
      <Box minHeight=".5rem" />
      <HorizontalStack align="end">
        <Button onClick={clearFilters} plain>
          Borrar filtros
        </Button>
      </HorizontalStack>
    </Card>
  );
};
